import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import { appUserLevels } from 'global/enums/globalEnums';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Label, Segment } from 'semantic-ui-react';
import { uniqueKey } from '../../../global/common/keys';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { _allowGolfEventUpdates } from '../cnr/reducers/GolfEventReducer';
import { GolferAdd } from './GolferAdd';
import GolferRow, { golferRowTypes, handicapModes } from './GolferRow';

export const golfersModes = {
  event: 'event',
  tournament: 'tournament',
  tournamentChange: 'tournamentChange',
  tournamentRecord: 'tournamentRecord',
}

export const golferHeaderModes = {
  handicap: 'handicap',
  record: 'record',
  opponents: 'opponents',
  // partners: 'partners',
}

const _getPlayerRecords = true


const Golfers = (props) => {

  const { golfersMode } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { states: states_parent, fns: fns_parents } = parentContext ?? {}
  const { database_fns, navigation_fns, appUser_fns } = fns_parents
  const { currentSettings_state } = states_parent

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { currentSwiperTab } = framework_state ?? {}

  const allowMods = appUser_fns.validateAccess_item(appUserLevels.superAdmin, true)

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers, fns } = golfParent_contexts ?? {}
  const { paps_state, item_state, golfEvent_state, golfTournament_state } = states ?? {}
  const { header_handlers, golfTournament_handlers } = handlers ?? {}

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  const { handleSubCaption } = header_handlers ? header_handlers : {}

  // uiItemContext 
  const { vldSorted: athletes } = item_state ?? {}
  const { pathViews } = paps_state ?? {}

  // pageContext   
  // golfEventContext  
  const { golfers: golfers_event, teams } = golfEvent_state ?? {}

  // golfTournamentContext  
  const { details, golfers: golfers_tournament, golferRecords } = golfTournament_state ?? {}
  const { teams: teams_tournament } = details ?? {}


  const [_golfers, set_golfers] = useState()
  const [handicapMode, setHandicapMode] = useState(handicapModes.event)
  const [golferHeaderMode, setGolferHeaderMode] = useState(golferHeaderModes.handicap)
  const [showAddGolfer, setShowAddGolfer] = useState()
  const [currentGolfer, setCurrentGolfer] = useState()
  const [thisUpdated, setThisUpdated] = useState()
  const [updating, setUpdating] = useState()
  const [showPaste, setShowPaste] = useState()
  const [golfer_partners, setGolfer_partners] = useState()

  let cn = 'golfers-container ' + handicapMode

  const ammendGolfers = () => {
    let glfs;
    if (pathViews.tournamentTeams) {
      glfs = golfers_tournament
      if (pathViews.tournamentTeams) {
        glfs = _.filter(glfs, { teamNumber: parseInt(pathViews.tournamentTeams) })
      }
      setHandicapMode(handicapModes.tournament)
    } else if (pathViews.golfTournaments) {
      switch (golferHeaderMode) {
        case golferHeaderModes.record:
        case golferHeaderModes.opponents:
          glfs = golferRecords
          break;
        case golferHeaderModes.partners:
          glfs = golfer_partners
          break;
        default:
          glfs = golfers_tournament
          break;
      }
      if (pathViews.tournamentTeams) {
        glfs = _.filter(glfs, { teamNumber: parseInt(pathViews.tournamentTeams) })
      }
      setHandicapMode(handicapModes.tournament)
    } else if (pathViews.events) {
      glfs = golfers_event
      setHandicapMode(handicapModes.event)
    } else {
      glfs = athletes
    }

    if (golfersMode === golfersModes.tournamentChange) {
      glfs = golfers_event
      Object.keys(golfers_tournament).forEach(gtkey => {
        if (glfs[gtkey]) { delete glfs[gtkey] }
      })
    }
    set_golfers(glfs)
  }

  useEffect(() => {
    if (allowMods) {
      framework_handlers.handleAdd_navigationItem('ammendHandicaps', { icon: 'edit', caption: _.startCase('ammendTournamentHandicapIndexes'), oc: handleAmmendThi, activeTabOnly: 'tournamentGolfers' });
      framework_handlers.handleAdd_navigationItem('addGolfer', { icon: 'add', caption: _.startCase('addGolfer'), oc: handleClick_addGolfer, activeTabOnly: 'tournamentGolfers' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentSwiperTab]);

  useEffect(() => {
    const team = teams_tournament ? teams_tournament['team' + pathViews.tournamentTeams] : null
    const { name } = team ?? {}
    if (name) { handleSubCaption(name) }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [teams_tournament]);

  useEffect(() => {
    ammendGolfers()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [golfers_tournament, golfers_event, golferHeaderMode]);



  const handleClick_golferHeader = (golfersHeaderMode) => setGolferHeaderMode(golfersHeaderMode)
  const handleClick_addGolfer = () => setShowAddGolfer(!showAddGolfer)

  const handleClick_golferRow = (item) => {
    const { _itemKey } = item ?? {}
    if (pathViews.golfTournaments) {
      navigation_fns.handleNav_item({ key: 'tournamentGolfers' }, _itemKey)
    } else {
      navigation_fns.handleNav_item({ key: 'golfers' }, _itemKey)
    }
  }

  const lbl = (value, index) => <Label
    key={uniqueKey('glfl', index)}
    size={'tiny'}
  >{value}
  </Label>

  const hcpLabelGroup = () => {
    let cn = 'golfer-hcps label-group'
    let lbls = []
    switch (handicapMode) {
      case handicapModes.event:
        lbls = [
          lbl('S', 2),
          lbl('H.I.', 3),
        ]
        cn += ' l3'
        break;

      case handicapModes.tournament:
        switch (golferHeaderMode) {
          case golferHeaderModes.opponents:
          case golferHeaderModes.partners:
            lbls = []
            break;
          case golferHeaderModes.record:
            lbls = []
            break;
          default:
            lbls = [
              lbl('App', 2),
              lbl('THI', 3),
              lbl('CH', 4)
            ]
            break;
        }
        cn += ' l4'
        break;

      default:
      // nothing
    }
    return <div key={uniqueKey('glfh')} className={cn}>{lbls}</div>
  }

  const golferRow_header = () => {
    const h = ['#', '', 'Name']
    const his = h.map((hi, index) => (<div key={uniqueKey('glfh', index)}  >{hi}</div>))
    his.push(hcpLabelGroup())
    return <div key={uniqueKey('glfh')} className={'golfer-row hdr'}>{his}</div>
  }

  const golferRow = (golfer, index) => <GolferRow
    key={uniqueKey('glf', index)}
    golferRowType={golferRowTypes.single}
    golfersMode={golfersMode}
    golferHeaderMode={golferHeaderMode}
    golfer={golfer}
    index={index}
    handicapMode={handicapMode}
    handleClick={handleClick_golferRow}
    ammendGolfers={ammendGolfers}
  />

  const golferRows = () => {
    const _orderBy = golferHeaderMode === golferHeaderModes.record ? ['points', 'lastName', 'firstName'] : ['lastName', 'firstName']
    const _desc = golferHeaderMode === golferHeaderModes.record ? ['desc', 'asc', 'asc'] : ['asc', 'asc']
    const glfs = _golfers ? _.orderBy(_golfers, _orderBy, _desc) : []
    if (glfs && glfs.length > 0) {
      return glfs.map((golfer, index) => (golferRow(golfer, index)))
    } else {
      return 'None'
    }
  }

  const golfer_labels = () => {
    const lbls = _.map(golferHeaderModes, (ghm) => (
      <Label color={golferHeaderMode === ghm ? 'blue' : 'grey'} onClick={(e) => { handleClick_golferHeader(ghm) }}>{_.startCase(ghm)}</Label>
    ))
    // isSuperAdminDeveloper && lbls.push(<Label color={'grey'} onClick={(e) => { handleClick_addGolfer() }}> <Icon name='add' />Add</Label>)
    return lbls
  }

  const content = () => <Segment basic className={cn}>
    {golferRow_header()}
    {golferRows()}
  </Segment>

  const footer_golfers = () => {

    const btns = []

    switch (handicapMode) {
      case handicapModes.tournament:
        if (thisUpdated) {
          btns.push({ oc: handleSaveThi, icon: 'save', caption: 'Save Tournament Handicap Indexes', color: _allowGolfEventUpdates.any && _allowGolfEventUpdates.golferUpdate ? 'green' : 'olive' })
        } else {
          // btns.push({ oc: handleAmmendThi, icon: 'arrow right', caption: 'Ammend Tournament Handicap Indexes', color: 'blue' })
        }
        break;
    }
    return <UiSaveButtons others={btns} />
  }

  const content_wrapper = () => <Wrapper
    header={golfer_labels()}
    content={showAddGolfer ? golfer_add() : content()}
    footer={isSuperAdminDeveloper && footer_golfers()}
    wrapperType={wrapperTypes.paddedHeader}
    css={{ header: 'glf-hdr' }}
  />

  const handleSaveThi = () => {
    const cb = () => {
      setUpdating()
      setThisUpdated(false)
    }
    setUpdating(true)
    golfTournament_handlers.handleUpdate_tournamentGolfersHandicaps(_golfers, cb)
  }

  const handleAmmendThi = () => {
    const glfs = _.cloneDeep(_golfers)
    _.forEach(glfs, (gt, gtk) => {
      gt.tournamentHandicapIndex = gt.handicapIndex
    })
    set_golfers(glfs)
    setThisUpdated(true)
  }

  const golfer_add = () => <GolferAdd
    currentGolfer={currentGolfer}
    handleCancel={handleClick_addGolfer}
    currentGolfers={_golfers}
    teams={teams}
  />

  return showAddGolfer ? golfer_add() : content_wrapper()
}

export default Golfers